import FooterFeature from '@jobseeker/feature-navigation/components/Footer';

import type {Props as FooterProps} from '@jobseeker/lotus/components/Footer/types';

const Footer = (props: FooterProps) => {
  return <FooterFeature {...props} data-testid="footer" />;
};

export default Footer;
